// Lib
import * as _ from 'lodash';
import { put, call, takeLatest } from "redux-saga/effects";

// Constants
import * as ACTIONS from "./actionTypes";

// Types
import { ActionGetListingsForDealerRequest, ActionListingsChangesRequestSuccess, ActionUseLocationAPI, getListingsForDealerError, getListingsForDealerSuccess, listingsChangesError, listingsChangesSuccess, updateLocationAPISuccess } from './actions';
import { ActionGetListingSyncErrorsRequest, getListingSyncErrorsError, getListingSyncErrorsSuccess } from './actions';
import { ActionGetDealerListingsWithErrorsRequest, getDealerListingsWithErrorsError, getDealerListingsWithErrorsSuccess } from './actions';
import { createAPINetworkInstance } from 'common/api';
import { parseChangedInfoAPI, parseListingAPI } from 'features/Dealers/Listings/state/utils';
import { parseListingSyncErrosAPI } from 'features/Dealers/Listings/state/utils';
import { parseDealerListingsWithErrosAPI } from 'features/Dealers/Listings/state/utils';
import { ActionGetLMValidationAPI,getLMValidationAPIError,getLMValidationAPISuccess } from './actions';

function* getListingForDealerAPI(action: ActionGetListingsForDealerRequest) {
    try {
        const { dealerId } = action
        const response = yield call(createAPINetworkInstance().get, `dealer/${dealerId}/listings`);
        
        const listings = (response.data?.listings ?? []).map(parseListingAPI);
        yield put(getListingsForDealerSuccess(listings));
    } catch (err) {
        yield put(getListingsForDealerError(err));
    }
}

function* getListingSyncErrosAPI(action: ActionGetListingSyncErrorsRequest) {
    try {
        const { listingId } = action
        const { data } = yield call(createAPINetworkInstance().get, `listing/${listingId}/errors`);
        const listingSyncErrors = parseListingSyncErrosAPI(data);
        yield put(getListingSyncErrorsSuccess(listingSyncErrors));
    } catch (err) {
        yield put(getListingSyncErrorsError(err));
    }
}

function* getDealerListingsWithErrosAPI(action: ActionGetDealerListingsWithErrorsRequest) {
    try {
        const { dealerId } = action
        const { data } = yield call(createAPINetworkInstance().get, `dealer/${dealerId}/listings/errors`);
        const syncErrors = parseDealerListingsWithErrosAPI(data);
        yield put(getDealerListingsWithErrorsSuccess(syncErrors));
    } catch (err) {
        yield put(getDealerListingsWithErrorsError(err));
    }
}

function* listingChangesAPI(action: ActionGetListingsForDealerRequest) {
    try {
        const { dealerId } = action
        const response = yield call(createAPINetworkInstance().get, `dealer/${dealerId}/listings/changed`);
        yield put(listingsChangesSuccess(parseChangedInfoAPI(response.data)));
    } catch (err) {
        yield put(listingsChangesError(err));
    }
}

function* useLocationAPI(action: ActionUseLocationAPI) {
    try {
        const { iddealer, locationId, accountId, restore } = action
        const response = yield call(createAPINetworkInstance().get, `chatmeter/dealer/${iddealer}/useLocation?location=${locationId}&account=${accountId}&restore=${restore}`);        
        const listings = (response.data?.listings ?? []).map(parseListingAPI);
        yield put(updateLocationAPISuccess(listings));
    } catch (err) {
        yield put(getListingsForDealerError(err));
    }
}

function* getLMValidation(action: ActionGetLMValidationAPI) {
    try {
        const { data } = yield call(createAPINetworkInstance().get, "/utils/lm_validation");
        yield put(getLMValidationAPISuccess(data));
    } catch (err) {
        yield put(getLMValidationAPIError());
    }
}

export default function* dealerLMConfigSagas() {
    yield takeLatest(ACTIONS.GET_LISTINGS_FOR_DEALER_API_REQUEST, getListingForDealerAPI);
    yield takeLatest(ACTIONS.GET_LISTING_SYNC_ERRORS_API_REQUEST, getListingSyncErrosAPI);
    yield takeLatest(ACTIONS.GET_DEALER_LISTINGS_WITH_ERRORS_API_REQUEST, getDealerListingsWithErrosAPI);
    yield takeLatest(ACTIONS.GET_LISTINGS_CHANGES_API_REQUEST, listingChangesAPI);
    yield takeLatest(ACTIONS.USECHATMETERLOCATION_API_REQUEST, useLocationAPI);
    yield takeLatest(ACTIONS.GET_LMVALIDATION_API_REQUEST, getLMValidation);
}